export default "__VITE_ASSET__2f94ebb8__"